import React, { createContext, useContext, useState } from "react";
import { SnackbarProvider } from "notistack";
import SiteRoutes from "./SiteRoutes";
import "./App.css";

const NightMode = createContext();
export const Nigtmode = () => useContext(NightMode);

function App() {
  const [isnightmode, setIsnightmode] = useState(false);
  return (
    <NightMode.Provider value={{ isnightmode }}>
      <SnackbarProvider
        maxSnack={6}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <section className="App">
          <SiteRoutes />
        </section>
      </SnackbarProvider>
    </NightMode.Provider>
  );
}

export default App;
